import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export enum RegistrationAction {
  GENERATE_REGISTRATION_TOKEN = "registration/generateRegistrationToken",
  CREATE_LEGAL_USER = "registration/createLegalUser",
}

export interface GenerateRegistrationTokenParams {
  language: string;
  country: string;
  email: string;
  isCompany: boolean;
  captchaToken: string;
  promoNotifications: boolean;
}

export interface CreateLegalUserParams {
  email: string;
  registrationCode: string;
  fullName: string;
  registrationNumber: string;
  taxIdNumber: string;
  referrerCode: string;
  joinReferralProgram: boolean;
}

let config = {
  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*',
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Credentials": true,
  }
};

export const generateRegistrationToken = createAsyncThunk(
  RegistrationAction.GENERATE_REGISTRATION_TOKEN,
  async (params: GenerateRegistrationTokenParams, thunkAPI) => {
    try {
      const response = await axios.post("/api/users/generate-registration-token", params, config).then(res => res.data);
      if (response.state === "ERROR" && response.result) {
        const error = response.result;
        return thunkAPI.rejectWithValue(error.description || error.message || "Registration token generation failed");
      }
      
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || "Registration token generation failed");
    }
  }
);

export const createLegalUser = createAsyncThunk(
  RegistrationAction.CREATE_LEGAL_USER,
  async (params: CreateLegalUserParams, thunkAPI) => {
    try {
      const response = await axios.post("/api/users/legal", params, config).then(res => res.data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data?.message || "User creation failed");
    }
  }
);

export const registrationActions = {
  generateRegistrationToken,
  createLegalUser,
};